import { jsx as _jsx } from "react/jsx-runtime";
import * as heroIconsSolid from '@heroicons/react/solid';
var renderIcon = function (iconName, className) {
    if (className === void 0) { className = ''; }
    var SelectedIcon = heroIconsSolid[iconName];
    return _jsx(SelectedIcon, { className: className });
};
export { renderIcon };
//# sourceMappingURL=icon-utils.js.map